module.exports = __webpack_public_path__ + "img/konfortify-fb.b9302934.png";